export default __webpack_public_path__ + "static/char-s-37-ja-ecebd6b5ab8521a6d572d14240189618.png";